module.exports = __webpack_public_path__ + "media/images/home/location-835f6aac9db6fe88cdc0640821022d57.png";